<template>
  <div class="small-24 cell">
    <span class="title">{{ bundleOption.title }}</span>
    <ul class="radio">
      <li v-for="selection in bundleOption.selections">
        <label :class="isSelected(bundleOption.option_id, selection.selection_id) ? '_active' : ''">
          <input :disabled="!selection.salable" required="bundleOption.required" type="radio" :name="'bundle_option[' + bundleOption.option_id + ']'" :value="selection.selection_id">
          <img v-show="selection.image" :src="selection.image" :alt="selection.name" width="42" height="42"/>
          <img v-show="!selection.image" :alt="selection.name" width="42" height="42"/>
          <span class="tooltip">{{ selection.name }}{{ parseFloat(selection.price) > 0 ? ' (+' + selection.price.priceFormat() + ')': '' }}</span>
        </label>
      </li>
    </ul>
    <input type="hidden" :name="'bundle_option_qty[' + bundleOption.option_id + ']'" value="1">
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-type-bundle-radio'
    }
  )

  export default class extends Vue {
    @Prop() bundleOption: object;

    protected selectedObjects: object = {};

    protected isSelected(optionId: number, valueId: number): boolean {
      if (!this.selectedObjects.hasOwnProperty(optionId)) {
        return false;
      }

      return this.selectedObjects[optionId] === valueId;
    }
  }
</script>
